import {
  lowBits2hhv195ivumfc as lowBits,
  highBitstfrzt3uu2jig as highBits,
} from './js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
var clz32 = Math.clz32;
//endregion
//region block: pre-declaration
//endregion
function isNaN_0(_this__u8e3s4) {
  return !(_this__u8e3s4 === _this__u8e3s4);
}
function isFinite(_this__u8e3s4) {
  return !isInfinite_0(_this__u8e3s4) && !isNaN_1(_this__u8e3s4);
}
function isFinite_0(_this__u8e3s4) {
  return !isInfinite(_this__u8e3s4) && !isNaN_0(_this__u8e3s4);
}
function countTrailingZeroBits(_this__u8e3s4) {
  var low = lowBits(_this__u8e3s4);
  return low === 0 ? 32 + countTrailingZeroBits_0(highBits(_this__u8e3s4)) | 0 : countTrailingZeroBits_0(low);
}
function rotateLeft(_this__u8e3s4, bitCount) {
  return _this__u8e3s4 << bitCount | (_this__u8e3s4 >>> (32 - bitCount | 0) | 0);
}
function isInfinite(_this__u8e3s4) {
  return _this__u8e3s4 === Infinity || _this__u8e3s4 === -Infinity;
}
function isInfinite_0(_this__u8e3s4) {
  return _this__u8e3s4 === Infinity || _this__u8e3s4 === -Infinity;
}
function isNaN_1(_this__u8e3s4) {
  return !(_this__u8e3s4 === _this__u8e3s4);
}
function countTrailingZeroBits_0(_this__u8e3s4) {
  // Inline function 'kotlin.countLeadingZeroBits' call
  var this_0 = ~(_this__u8e3s4 | (-_this__u8e3s4 | 0));
  return 32 - clz32(this_0) | 0;
}
function countLeadingZeroBits(_this__u8e3s4) {
  var high = highBits(_this__u8e3s4);
  var tmp;
  if (high === 0) {
    // Inline function 'kotlin.countLeadingZeroBits' call
    var this_0 = lowBits(_this__u8e3s4);
    tmp = 32 + clz32(this_0) | 0;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = clz32(high);
  }
  return tmp;
}
function takeHighestOneBit(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === 0) {
    tmp = 0;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = 1 << (31 - clz32(_this__u8e3s4) | 0);
  }
  return tmp;
}
//region block: exports
export {
  countLeadingZeroBits as countLeadingZeroBits1tnrq8lk0emwh,
  countTrailingZeroBits as countTrailingZeroBits1k55x07cygoff,
  isFinite_0 as isFinite2t9l5a275mxm6,
  isFinite as isFinite1tx0gn65nl9tj,
  isInfinite as isInfinite12nl8hpz1hbp2,
  isNaN_0 as isNaNymqb93xtq8w8,
  rotateLeft as rotateLeft386qqkr4zb8q2,
  takeHighestOneBit as takeHighestOneBit9p7rdtda63bc,
};
//endregion

//# sourceMappingURL=NumbersJs.mjs.map
